import React from 'react';
import { DialogFrame } from './Dialog';

export interface AlertDialogProps {
  open: boolean;
  title: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  /** The decision buttons; there is no close button. */
  actions: React.ReactNode;
  className?: string;
}

/** Blocking prompt that needs an answer (e.g. approve a redeem). Never dismissible. */
export default function AlertDialog({ open, title, description, children, actions, className }: AlertDialogProps) {
  return (
    <DialogFrame
      open={open}
      onClose={() => {}}
      title={title}
      description={description}
      footer={actions}
      dismissible={false}
      placement="center"
      size="sm"
      role="alertdialog"
      layer="blocking"
      className={className}
    >
      {children}
    </DialogFrame>
  );
}
